import React, { FC, useEffect, useState } from 'react'
import { Nav, Navbar } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import AuthenticationContext from '../Authentication/AppContext'
import AuthService from '../Authentication/AuthService'
import { useNav } from '../routing/AppRouter'
import { routes } from '../routing/Routes'

export const Sidebar: FC<{}> = () => {
  return (
    <Navbar bg='dark' variant='dark' collapseOnSelect expand='md' className='shadow-sm p-2 h-100 w-100 position-sticky' sticky='top'>
      <Navbar.Toggle aria-controls='responsive-navbar-nav' />
      <Navbar.Collapse id='responsive-navbar-nav' className='mr-auto flex-column h-100 w-100'>
        <NavBox title={'Gateway'} routes={routes} />
      </Navbar.Collapse>
    </Navbar>
  )
}

const NavBox: FC<{ title: string; routes: Array<any> }> = ({ title, routes }) => {
  const [activePath, setPath] = useNav(useHistory())
  return (
    <div className='mr-auto mb-2 w-100'>
      <Nav className='mr-auto flex-column w-100' onSelect={setPath}>
        {routes.map(({ path, title, content, permissions }) => (
          <React.Fragment key={path}>
            <ProtectedNavLink
              eventKey={path}
              active={isCurrentPathActive(activePath, path, content)}
              className='p-0 pl-2 mb-1 text-break text-break-all'
              title={title}
              permissions={permissions}
            />

            {isCurrentPathActive(activePath, path, content) &&
              (content.subTabs instanceof Function ? (
                <PromiseSubTypes activePath={activePath} subTabsPromise={content.subTabs} />
              ) : (
                createProtectedNavLink(activePath, content.subTabs)
              ))}
          </React.Fragment>
        ))}
      </Nav>
    </div>
  )
}

function createProtectedNavLink(activePath: string, subTabs?: any[]) {
  return subTabs?.map((tab: any) => (
    <ProtectedNavLink
      key={tab.path}
      eventKey={tab.path}
      active={isCurrentPathActive(activePath, tab.path)}
      className='p-0 pl-4 mb-1 text-overflow'
      title={tab.title}
      permissions={tab.permissions}
    />
  ))
}

function isCurrentPathActive(activePath: string, path: string, content?: any) {
  if ((Array.isArray(content?.subTabs) && content.subTabs?.length) || content?.subTabs instanceof Function) {
    return activePath.startsWith(path)
  } else {
    return activePath === path
  }
}

const PromiseSubTypes: FC<{ activePath: string; subTabsPromise: () => Promise<any[]> }> = ({ activePath, subTabsPromise }) => {
  const [subTabs, setSubTabs] = useState([] as any[])
  useEffect(() => {
    subTabsPromise().then((subs: any[]) => setSubTabs(subs))
  }, [subTabsPromise])
  return <>{createProtectedNavLink(activePath, subTabs)}</>
}

type ProtectedNavLinkType = {
  eventKey: string
  active: boolean
  title: string
  permissions: string[]
  className?: string
}

const ProtectedNavLink: FC<ProtectedNavLinkType> = ({ eventKey, active, title, permissions, className = '' }) => {
  const { userPermissions } = React.useContext(AuthenticationContext)
  return (
    <>
      {AuthService.hasPermission(userPermissions, permissions) && (
        <Nav.Link active={active} eventKey={eventKey} className={className} title={title}>
          {title}
        </Nav.Link>
      )}
    </>
  )
}
